import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { PACK_QUERY_KEY } from "../../constants";
import { Pack } from "../../packs.types";
import { requestGetPack } from "./getPack.request";

const useGetPack = (
  packId: string | undefined,
  options?: QueryOptions<Pack, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: [PACK_QUERY_KEY, packId],
    queryFn: async () => await requestGetPack(packId as string),
    enabled: !!packId,
    onError: toastServerError,
    ...options
  });

  return { pack: data, ...rest };
};

export default useGetPack;
